import { useState } from "react";
import { ItemType } from "../../../models/ViewModels/RecordCatalogViewModel";
import {
  FamilyHistoryItem,
  FamilyHistoryType,
} from "../../../models/ViewModels/RecordViewModel";
import { LoadingFit } from "../../../share/Components";
import {
  Icon,
  ProvideTypeahead,
  Select,
  TextBox,
  Typeahead,
} from "../../../share/Elements";
import { TextBoxTypeEnum } from "../../../enums/TextBoxTypeEnum";
import Card from "../../../share/Components/Card/Card";

type TypeaheadData = {
  show: boolean;
  data?: any;
};

const RecordFamilyHistory = ({
  catalogs,
  relatives,
  item,
  onItemChange,
}: {
  catalogs?: Array<ItemType<string>>;
  relatives?: Array<ItemType<number>>;
  item?: FamilyHistoryType;
  onItemChange?: (updatedItem: FamilyHistoryType) => void; // A function to handle item changes
}) => {
  const [familyItem, setFamilyItem] = useState<FamilyHistoryItem>({
    relatedPersonId: relatives![0].id,
    diseaseId: catalogs![0].id,
  });

  function getRelativeById(id) {
    const relative = relatives?.find((item) => item.id === id);
    return relative ? relative.title : "";
  }
  function getDiseaseId(id) {
    const disease = catalogs?.find((item) => item.id === id);
    return disease ? disease.title : "";
  }
  const handleAddItem = () => {
    const updatedItems = item?.items ? [...item.items] : [];
    updatedItems.push(familyItem!);

    const updatedFamily: FamilyHistoryType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(updatedFamily);
    setFamilyItem({
      ...familyItem,
      description: "",
    });
  };
  const handleAbstractClick = (index: number) => {
    // Handle abstract click logic

    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    };

    const familyData: FamilyHistoryType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(familyData);
  };

  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  return (
    <>
      <div className="p-6 ">
        <div className="grid xs:grid-cols-12 grid-cols-2 gap-2 mt-2">
          <Select
            className="w-full h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setFamilyItem({
                  ...familyItem,
                  diseaseId: e.target.value,
                });
              }
            }}
            value={getDiseaseId(familyItem?.diseaseId!)}
          >
            {catalogs?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
          <Select
            className="w-full h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setFamilyItem({
                  ...familyItem,
                  relatedPersonId: Number(e.target.value),
                });
              }
            }}
            value={getRelativeById(familyItem?.relatedPersonId!)}
          >
            {relatives?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
        </div>
        <div className=" mt-3 grid  grid-cols-9 items-center">
          <div className="col-span-8">
            <TextBox
              innerText="توضیحات"
              debounceTime={0}
              className="w-full "
              Type={TextBoxTypeEnum.Text}
              value={familyItem?.description}
              onChange={(e) =>
                setFamilyItem({ ...familyItem, description: e.target.value })
              }
            />
          </div>
        </div>
        <div className="flex justify-between items-center mt-3 px-1">
          <Icon
            icon="rayteb-add-circular"
            className="text-xl mr-auto text-primaryLight"
            onClick={handleAddItem}
          />
        </div>
        <div className="mt-5 grid grid-cols-1 gap-1 ">
          {item?.items?.length! > 0
            ? item?.items?.map((n, i) => (
              <Card
                key={i}
                text={getDiseaseId(n?.diseaseId)}
                footer={
                  <CardFooter
                    item={n}
                    onAbstractClick={() => handleAbstractClick(i)}
                    onDeleteClick={() => handleDeleteClick(i)}
                  />
                }
              >
                <span className="text-[9px] text-primaryLight ml-1  font-bold"></span>
                <br />
                <span className="text-xs text-primaryLight ml-1 font-bold">
                  {getRelativeById(n.relatedPersonId)}
                </span>
              </Card>
            ))
            : null}
        </div>
      </div>
    </>
  );
};
const CardFooter = ({
  item,
  onAbstractClick,
  onDeleteClick,
}: {
  item?: FamilyHistoryItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex  justify-between items-center pt-3">
      <div className="bg-white py-1 text-xs text-primary">
        {item?.description}
      </div>

      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${item?.showAbstract ? "text-primary" : "text-disable"
            }`}
          onClick={onAbstractClick}
        />
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
      </div>
    </div>
  </>
);
export default RecordFamilyHistory;
